import { gql } from '@apollo/client';

/**
 * GraphQL mutation to create a custom label
 */
export const CREATE_CUSTOM_LABEL = gql`
  mutation CreateCustomLabel($communityId: ID!, $input: CreateCustomLabelInput!) {
    createCustomLabel(communityId: $communityId, input: $input) {
      label {
        id
        communityId
        name
        description
        labelType
        active
      }
    }
  }
`;
